import axios from '@/utils/api'

const actions = {
  async getItems ({ commit }, filtro) {
    const data = await axios({
      url: `cadastro/filter`,
      method: 'POST',
      data: filtro
    })
    return data
  },

  async getItemsProcessos ({ commit }, filtro) {
    const data = await axios({
      url: `cadastro/filter/processos`,
      method: 'POST',
      data: filtro
    })
    return data
  },

  async delete ({ commit }, idCadastro) {
    await axios({
      url: `cadastro/${idCadastro}`,
      method: 'DELETE'
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cadastro/listagem.js